import React, { useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./printStyle.css";
import { useListSettings } from "../component/api/setting";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PsychoLayout = ({ html, data, category }) => {
  const printRef = useRef(null);
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const { data: settings } = useListSettings();

  useEffect(() => {
    if (!userInfo) {
      navigate("/signin");
    }
  }, [userInfo, navigate]);

  const printAction = () => {
    const printContent = printRef.current;
    const printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
            }
            body {
              margin: 0;
              padding: 0;
              font-family: Arial, sans-serif;
              line-height: 1.3;
              min-height :100vh;
            }
.header {
  width: 100%;
  text-align: center;
  z-index: 9999;
  overflow: hidden;
}

.header img {
  display: block;
  width: 100%;      
  height: 150px;    
  object-fit: fill;
}

            .header-section {
            height : 80px;
            }

            table.report-container {
              page-break-after:always;
              }
        thead.report-header {
               display:table-header-group;
           }

    
            .content  {
              width : 90%;
              flex: 1;
              margin:2cm;
              margin: 0 auto;
              z-index: 1;
            }
            @media print {
              ${
                category === "expense"
                  ? "@page { margin: 0; size: A5 }"
                  : "@page { margin: 0; size: A4 }"
              }
              .print-button { display: none; }
            }
          </style>
        </head>
        <body>
         <table class="report-container">
        <thead class="report-header">
     <tr>
        <th class="report-header-cell">
           <div class="header-info header">
              ${settings?.data?.[`${category}`]?.header
        ? `<img src=${settings.data[`${category}`]?.header
        }  class="header" />`
        : ""
      }
          </th>
          </tr>
             <td class="report-content-cell">
            <div class="main" >
              ${html(data)}
              </div>
              </td>
              </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div ref={printRef}>
      <div className="print-button d-flex justify-content-end mt-3">
        <Button variant="primary" onClick={printAction}>
          Print
        </Button>
      </div>
    </div>
  );
};

export default PsychoLayout;
